export default __webpack_public_path__ + "./images/mr.5e05f23f.png";